import { graphql } from 'relay-runtime'

export const postPageBuildTargetQuery = graphql`
  query postPage_buildTargetQuery($from: Int!) {
    listPosts(
      filter: { status: "published" }
      page: { from: $from, size: 50 }
    ) {
      items {
        slug
        redirect_to
      }
      pagination {
        hasNext
        to
      }
    }
  }
`

export const postPagePreQuery = graphql`
  query postPage_preQuery($slug: String!) {
    post: getPost(slug: $slug) {
      template_name
      parent_post {
        slug
      }
      status
      redirect_to
      shortcodes {
        category
        code
        params {
          key
          value
        }
      }
    }
  }
`

export const postPageIndexQuery = graphql`
  query postPage_indexQuery(
    $slug: String!
    $page: PaginationInput!
    $shortCodeCemeteryIds: [Int!]!
    $requestShortCodeCemeteryIdSize: Int!
    $shortCodeSlugs: [String!]!
    $requestShortCodeSlugSize: Int!
    $parentSlug: [String]
  ) {
    post: getPost(slug: $slug) {
      ...Post_post
      ...PostList_post
      ...PostStructuredData_post
      ...PostSeoHead_post
      ...Breadcrumb_post
      ...RelatedPosts_post
      ...PostNoTitle_post
      child_posts(page: $page) {
        ...PostList_posts
      }
      parent_post {
        short_title
      }
      template_name
      status
      redirect_to
    }
    shortCodeCemeteries: listCemeteries(
      filter: { ids: $shortCodeCemeteryIds }
      page: { from: 0, size: $requestShortCodeCemeteryIdSize }
    ) {
      ...ShortCodeContextProvider_cemeteryFragment
    }
    shortCodePosts: listPosts(
      filter: { slugs: $shortCodeSlugs }
      page: { from: 0, size: $requestShortCodeSlugSize }
    ) {
      ...ShortCodeContextProvider_postFragment
    }
    newlyPosts: listPosts(
      filter: { template_name: "show_post" }
      page: { from: 0, size: 5 }
    ) {
      ...PostListCard_posts
    }
    newlyCemeteryPosts: listPosts(
      filter: { parent_slugs: ["ohaka"] }
      page: { from: 0, size: 5 }
    ) {
      ...PostListCard_posts
    }
    sameParentPosts: listPosts(
      filter: { parent_slugs: $parentSlug }
      page: { size: 8 }
    ) {
      ...SameParentPostList_Fragment
    }
  }
`
